function productFloatScroll(){
  try{
    // スクロールの速度
    var speed = 0; // ミリ秒で記述
    var position = 0;
    $('body,html').animate({scrollTop:0}, speed, 'swing');
    return false;
  }catch(e){}
}